export default [
  /**
   * 列表
   */
  {path: '/questionnaire/index', component: () => import('../page/questionnaire/index')},
  /**
   * 住院
   */
  {path: '/questionnaire/zy', component: () => import('../page/questionnaire/zy')},
  /**
   * 列表
   */
  {path: '/questionnaire/list', component: () => import('../page/questionnaire/list')},
  /**
   * 天瑞列表
   */
  {path: '/questionnaire/trlist', component: () => import('../page/questionnaire/trlist')},
  /**
   * 详情
   */
  {path: '/questionnaire/detail', component: () => import('../page/questionnaire/detail')},
  /**
   * 提交
   */
  {path: '/questionnaire/submit', component: () => import('../page/questionnaire/submit')},
  /**
   * 天瑞问卷提交
   */
  {path: '/questionnaire/trsubmit', component: () => import('../page/questionnaire/trsubmit')},
  /**
   * 住院问卷提交
   */
  {path: '/questionnaire/zysubmit', component: () => import('../page/questionnaire/zysubmit')},
  /**
   * 结果
   */
  {path: '/questionnaire/result', component: () => import('../page/questionnaire/result')},
  /**
   * 天瑞结果
   */
  {path: '/questionnaire/trresult', component: () => import('../page/questionnaire/trresult')}
]



// WEBPACK FOOTER //
// ./src/router/questionnaire.js